// @constants
const translations = require('./contractAresLoan.translations');

export default {
  WIZARD: {
    stepsAmount: 2,
    showPreLeaveModal: true,
    tealiumEvents: {
      next: { eventName: 'siguiente' },
      previous: { eventName: 'anterior' },
      cancel: { eventName: 'abandonar' },
      finish: { eventName: 'contratar' },
    }
  },
  WIZARD_STEP_1: {
    position: 'first',
    nextButton: true,
    nextButtonDisabled: false,
    cancelButton: true,
  },

  WIZARD_STEP_2: {
    position:'last',
    addLoadingBehaviour: true,
    cancelButton: true,
    immFinalButton: translations.WIZARD_CONTRACT_BUTTON,
  },

};